exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-list{background-color:#fff;height:100%;overflow:hidden}.igx-list__empty,.igx-list__empty--custom{display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;height:inherit}.image{width:auto;max-height:120px}.message{text-align:center;color:#333;padding:1em;z-index:1}igx-list-item{display:block;position:relative;list-style-type:none;user-select:none}.igx-list__header{align-items:center;color:#e41c77;font-size:.8125em;font-weight:400;height:3em;line-height:3em;user-select:none}.igx-list__header,.igx-list__item{display:flex;background-color:#fff;padding:.5em 1em}.igx-list__item{position:relative;flex-flow:column wrap;justify-content:center;min-height:3em;font-size:1em;color:rgba(0,0,0,.74);z-index:2}.igx-list__item:active{background-color:rgba(0,0,0,.04);z-index:3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/list/list.component.scss
// module id = 75
// module chunks = 0 1